var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay_text"},[_vm._v(" "+_vm._s(_vm.$t('template.overlay_text'))+" "),(_vm.redirectLink)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('template.overlay_redirect_link_var', {
        payment_method: _vm.getPaymentMethodName(),
        url: _vm.redirectLink
      }))}}):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }